/**
 * File: bfwt-pills-block.js
 * Purpose: Handles interactions for the Pills Block widget (e.g., Mission Navigation expand/collapse).
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // Mission Nav Toggle (Choose Your Mission — mobile collapse)
    // Works in tandem with CSS transition on max-height for smooth expansion
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.bfwt-mission-nav__toggle');
      if (!btn) return;

      const nav =
        btn.previousElementSibling ||
        btn.parentElement.querySelector('.bfwt-mission-nav');
      if (!nav) return;

      const expanded = nav.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);

      const text = btn.querySelector('.bfwt-mission-nav__toggle-text');
      if (text)
        {text.textContent = expanded ? 'Show Less' : 'Show All Categories';}

      // A11y Announcement
      if (window.BFWT_Accessibility) {
        window.BFWT_Accessibility.announce(
          expanded ? 'Categories expanded' : 'Categories collapsed'
        );
      }
    });
  });
})();
